export function getView(show_financials_managed_externally) {
  return show_financials_managed_externally
    ? 'FinancialsManagedExternally'
    : 'Normal'
}
